import {
  BankAccountAuditModel,
  BankAccountModel,
  LandlordDetailModel,
  LandlordListModel,
  LandlordListRowModel,
  LandlordUnitModel
} from '../models/landlord.model';
import {
  BankAccountAuditUIModel,
  BankAccountFormUIModel,
  BankAccountUIModel,
  BankDetailsStatus,
  LandlordDetailUIModel,
  LandlordListUIModel,
  LandlordRowUIModel,
  LandlordUnitUIModel
} from '../ui-models/landlord.ui-model';

const text = (value?: string | null): string =>
  value === null || value === undefined ? '' : String(value);

function mapBankAccountToUI(model: BankAccountModel | null): BankAccountUIModel | null {
  if (!model) {
    return null;
  }

  return {
    id: model._id,
    landlordId: text(model.landlordId),
    bankName: text(model.bankName),
    accountHolderName: text(model.accountHolderName),
    accountNumber: text(model.accountNumber),
    swiftBic: text(model.swiftBic),
    country: text(model.country),
    currency: text(model.currency),
    lastUpdatedAt: text(model.updatedAt),
    lastUpdatedBy: text(model.updatedByName || model.createdByName)
  };
}

function mapRowToUI(model: LandlordListRowModel): LandlordRowUIModel {
  return {
    landlordId: text(model.landlordId),
    name: text(model.name),
    email: text(model.email),
    phone: text(model.phone),
    unitsCount: model.unitsCount || 0,
    bankDetailsStatus: model.hasBankAccount ? BankDetailsStatus.SET : BankDetailsStatus.MISSING,
    lastUpdatedAt: text(model.bankDetailsUpdatedAt)
  };
}

function mapListToUI(model: LandlordListModel): LandlordListUIModel {
  return {
    rows: (model.rows || []).map(mapRowToUI),
    page: model.page,
    pageSize: model.pageSize,
    total: model.total || 0,
    totalMissingBankDetails: model.totalMissingBankDetails || 0
  };
}

function mapUnitToUI(model: LandlordUnitModel): LandlordUnitUIModel {
  return {
    id: text(model.id === undefined || model.id === null ? '' : String(model.id)),
    name: text(model.name || model.shortName),
    propertyName: text(model.projectName),
    areaName: text(model.areaName),
    landlordShare: model.landlordShare || 0
  };
}

function mapAuditToUI(model: BankAccountAuditModel): BankAccountAuditUIModel {
  return {
    action: text(model.action),
    source: text(model.source),
    batchId: text(model.batchId),
    changes: model.changes || [],
    performedBy: text(model.performedByName),
    performedAt: text(model.performedAt)
  };
}

function mapDetailToUI(model: LandlordDetailModel): LandlordDetailUIModel {
  return {
    landlordId: text(model.landlordId),
    name: text(model.profile && model.profile.name),
    email: text(model.profile && model.profile.email),
    phone: text(model.profile && model.profile.phone),
    bankAccount: mapBankAccountToUI(model.bankAccount),
    units: (model.units || []).map(mapUnitToUI),
    audit: (model.audit || []).map(mapAuditToUI)
  };
}

function mapFormToModel(form: BankAccountFormUIModel) {
  return {
    bankName: form.bankName.trim(),
    accountHolderName: form.accountHolderName.trim(),
    accountNumber: form.accountNumber.trim(),
    swiftBic: form.swiftBic.trim(),
    country: form.country.trim(),
    currency: form.currency.trim()
  };
}

export default {
  mapListToUI,
  mapDetailToUI,
  mapBankAccountToUI,
  mapFormToModel
};
